const CRYPTO_IDS = "bitcoin";
const CURRENCY = "usd";
const REFRESH_INTERVAL = 300000; // 5 minutes
const COINGECKO_API_KEY = "CG-5rVHueGfsHrkxRw4sU13STRm";

// Stores latest BTC price in USD for product price conversion
let btcPriceUSD = null;

const COIN_META = {
  bitcoin: { name: "Bitcoin", symbol: "BTC" },
};

function formatPrice(price) {
  if (price >= 1) return price.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return price.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 6 });
}

function drawSparkline(canvas, prices, isPositive) {
  if (!canvas || !prices || prices.length === 0) return;
  const ctx = canvas.getContext("2d");
  const dpr = window.devicePixelRatio || 1;
  const w = canvas.offsetWidth;
  const h = canvas.offsetHeight;
  canvas.width = w * dpr;
  canvas.height = h * dpr;
  ctx.scale(dpr, dpr);

  const min = Math.min(...prices);
  const max = Math.max(...prices);
  const range = max - min || 1;

  ctx.beginPath();
  ctx.strokeStyle = isPositive ? "#16a34a" : "#dc2626";
  ctx.lineWidth = 1.2;
  ctx.lineJoin = "round";

  const step = w / (prices.length - 1);
  prices.forEach((p, i) => {
    const x = i * step;
    const y = h - ((p - min) / range) * (h - 4) - 2;
    if (i === 0) ctx.moveTo(x, y);
    else ctx.lineTo(x, y);
  });
  ctx.stroke();
}

function buildCoinHTML(coin) {
  const meta = COIN_META[coin.id] || { name: coin.name, symbol: coin.symbol };
  const change = coin.price_change_percentage_24h || 0;
  const isUp = change >= 0;
  const dirClass = isUp ? "up" : "down";

  return `
    <div class="crypto-sidebar__coin">
      <img class="crypto-sidebar__icon" src="${coin.image}" alt="${meta.name}" width="28" height="28" loading="lazy">
      <span class="crypto-sidebar__coin-name">${meta.name} <span class="crypto-sidebar__coin-symbol">${meta.symbol}</span></span>
      <span class="crypto-sidebar__price">${formatPrice(coin.current_price)}</span>
      <div class="crypto-sidebar__change-row">
        <span class="crypto-sidebar__change crypto-sidebar__change--${dirClass}">
          <span class="crypto-sidebar__arrow crypto-sidebar__arrow--${dirClass}"></span>
          ${Math.abs(change).toFixed(2)}%
        </span>
        <canvas class="crypto-sidebar__sparkline" data-coin-id="${coin.id}"></canvas>
      </div>
    </div>
  `;
}

async function fetchCryptoPrices() {
  const list = document.getElementById("crypto-list");

  try {
    const headers = COINGECKO_API_KEY ? { "x-cg-demo-api-key": COINGECKO_API_KEY } : {};
    const res = await fetch(
      `https://api.coingecko.com/api/v3/coins/markets?vs_currency=${CURRENCY}&ids=${CRYPTO_IDS}&sparkline=true&price_change_percentage=24h`,
      { headers }
    );
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const coins = await res.json();

    // Sort to keep consistent order: BTC, ETH, SOL
    const order = CRYPTO_IDS.split(",");
    coins.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));

    // Store BTC price for product price conversion
    const btcCoin = coins.find((c) => c.id === "bitcoin");
    if (btcCoin) {
      btcPriceUSD = btcCoin.current_price;
      updateProductBtcPrices();
    }

    if (!list) return;

    list.innerHTML = coins.map(buildCoinHTML).join("");

    // Draw sparklines after DOM update
    requestAnimationFrame(() => {
      coins.forEach((coin) => {
        const canvas = list.querySelector(`canvas[data-coin-id="${coin.id}"]`);
        const prices = coin.sparkline_in_7d?.price;
        if (canvas && prices) {
          // Use last 48 data points (~2 days) for a cleaner line
          const recent = prices.slice(-48);
          const isPositive = (coin.price_change_percentage_24h || 0) >= 0;
          drawSparkline(canvas, recent, isPositive);
        }
      });
    });
  } catch (err) {
    console.error("Crypto fetch error:", err);
    // Keep existing content on error; only show message if still loading
    if (list && list.querySelector(".crypto-sidebar__loading")) {
      list.innerHTML = '<div style="text-align:center;padding:16px 0;color:#b4b4b4;font-size:12px;">Unable to load prices</div>';
    }
  }
}

/**
 * Converts USD cents to BTC with a 30% markup and formats the result.
 */
function usdCentsToBtc(cents) {
  if (!btcPriceUSD || isNaN(cents) || cents <= 0) return null;
  const usd = cents / 100;
  const usdWithMarkup = usd * 1.3; // 30% markup for crypto payments
  const btc = usdWithMarkup / btcPriceUSD;
  return btc.toFixed(8).replace(/0+$/, "").replace(/\.$/, "");
}

/**
 * Finds all product price elements with data-price-cents and
 * inserts/updates a BTC equivalent badge next to each price.
 */
function updateProductBtcPrices() {
  if (!btcPriceUSD) return;
  document.querySelectorAll("[data-price-cents]").forEach((el) => {
    const cents = parseInt(el.getAttribute("data-price-cents"), 10);
    const btcFormatted = usdCentsToBtc(cents);
    if (!btcFormatted) return;

    // Insert badge after the visible price-item span (regular or sale)
    const priceItem =
      el.querySelector(".f\\:price-item--sale:not(.f\\:price__compare)") ||
      el.querySelector(".f\\:price-item--regular") ||
      el.querySelector(".money--last") ||
      el.querySelector(".money");

    const target = priceItem || el;

    let badge = el.querySelector(".btc-price-badge");
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "btc-price-badge";
      target.parentNode.insertBefore(badge, target.nextSibling);
    }
    badge.textContent = `₿${btcFormatted}`;
  });
}

function initCryptoSidebar() {
  const toggle = document.getElementById("crypto-toggle");
  const mobileHandle = document.getElementById("crypto-mobile-handle");
  const sidebar = document.getElementById("crypto-sidebar");

  if (sidebar) {
    // Start collapsed on mobile
    if (window.innerWidth <= 768) {
      sidebar.setAttribute("data-expanded", "false");
    }

    function toggleSidebar() {
      const expanded = sidebar.getAttribute("data-expanded") === "true";
      sidebar.setAttribute("data-expanded", expanded ? "false" : "true");
    }

    if (toggle) toggle.addEventListener("click", toggleSidebar);
    if (mobileHandle) mobileHandle.addEventListener("click", toggleSidebar);
  }

  // Always fetch prices (sidebar + BTC product price conversion)
  fetchCryptoPrices();
  setInterval(fetchCryptoPrices, REFRESH_INTERVAL);

  // Initialize crypto checkout modal
  initCryptoCheckout();
}

/* ── Crypto Checkout Modal ── */

function initCryptoCheckout() {
  const overlay = document.getElementById("crypto-checkout-overlay");
  if (!overlay) return;

  // Close on overlay click (outside modal)
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) window.CryptoCheckout.close();
  });

  // Close on Escape key
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && overlay.style.display !== "none") {
      window.CryptoCheckout.close();
    }
  });

  // Handle form submission
  const form = document.getElementById("crypto-checkout-form");
  if (form) {
    form.addEventListener("submit", handleCryptoCheckoutSubmit);
  }
}

window.CryptoCheckout = {
  open() {
    const overlay = document.getElementById("crypto-checkout-overlay");
    if (!overlay) return;
    overlay.style.display = "flex";
    overlay.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";

    // Show form step, hide others
    showCheckoutStep("form");

    // Build cart summary
    buildCryptoCartSummary();
  },

  close() {
    const overlay = document.getElementById("crypto-checkout-overlay");
    if (!overlay) return;
    overlay.style.display = "none";
    overlay.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  },
};

async function buildCryptoCartSummary() {
  const container = document.getElementById("crypto-checkout-cart-summary");
  if (!container) return;

  try {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    if (!cart.items || cart.items.length === 0) {
      container.innerHTML = '<p class="crypto-checkout-cart-summary__empty">Your cart is empty.</p>';
      return;
    }

    const itemsHTML = cart.items
      .map((item) => {
        const usdPrice = (item.final_line_price / 100).toFixed(2);
        const btcPrice = usdCentsToBtc(item.final_line_price) || "—";
        return `
          <div class="crypto-checkout-cart-item">
            <span class="crypto-checkout-cart-item__name">${item.title} &times; ${item.quantity}</span>
            <span class="crypto-checkout-cart-item__price">$${usdPrice} | <span class="crypto-btc-highlight">₿${btcPrice}</span></span>
          </div>
        `;
      })
      .join("");

    const totalUsd = (cart.total_price / 100).toFixed(2);
    const totalBtc = usdCentsToBtc(cart.total_price) || "—";

    container.innerHTML = `
      ${itemsHTML}
      <div class="crypto-checkout-cart-total">
        <span>Total (with crypto rate)</span>
        <span>$${(cart.total_price / 100 * 1.3).toFixed(2)} | <span class="crypto-btc-highlight">₿${totalBtc}</span></span>
      </div>
    `;
  } catch (err) {
    console.error("Failed to load cart for crypto checkout:", err);
    container.innerHTML = '<p>Unable to load cart details.</p>';
  }
}

function showCheckoutStep(step) {
  ["form", "confirm", "loading"].forEach((s) => {
    const el = document.getElementById(`crypto-checkout-step-${s}`);
    if (el) el.style.display = s === step ? "block" : "none";
  });
}

async function handleCryptoCheckoutSubmit(e) {
  e.preventDefault();
  const form = e.target;

  // Basic validation
  const required = form.querySelectorAll("[required]");
  let valid = true;
  required.forEach((input) => {
    if (!input.value.trim()) {
      input.classList.add("crypto-checkout-form__input--error");
      valid = false;
    } else {
      input.classList.remove("crypto-checkout-form__input--error");
    }
  });
  if (!valid) return;

  showCheckoutStep("loading");

  // Gather form data
  const formData = new FormData(form);
  const data = {};
  formData.forEach((v, k) => (data[k] = v));

  // Fetch cart for order details
  let cartInfo = "Unable to fetch cart";
  try {
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();
    const totalBtc = usdCentsToBtc(cart.total_price) || "N/A";
    const totalUsdMarkup = (cart.total_price / 100 * 1.3).toFixed(2);
    cartInfo = cart.items
      .map((item) => `${item.title} x${item.quantity} — $${(item.final_line_price / 100).toFixed(2)}`)
      .join("\n");
    cartInfo += `\n\nSubtotal (USD): $${(cart.total_price / 100).toFixed(2)}`;
    cartInfo += `\nTotal with crypto rate (30% markup): $${totalUsdMarkup}`;
    cartInfo += `\nTotal (BTC): ₿${totalBtc}`;
    if (btcPriceUSD) cartInfo += `\nBTC/USD rate at time of order: $${btcPriceUSD.toLocaleString()}`;
  } catch (err) {
    console.error("Cart fetch error:", err);
  }

  // Build email body
  const emailBody = [
    `CRYPTO ORDER REQUEST`,
    `====================`,
    ``,
    `Customer: ${data.first_name} ${data.last_name}`,
    `Email: ${data.email}`,
    `Phone: ${data.phone || "N/A"}`,
    ``,
    `Shipping Address:`,
    `${data.address}`,
    `${data.city}, ${data.state || ""} ${data.zip || ""}`,
    `${data.country}`,
    ``,
    `Order Notes: ${data.notes || "None"}`,
    ``,
    `ORDER ITEMS:`,
    `${cartInfo}`,
  ].join("\n");

  // Submit via Shopify's contact form (sends email to store owner / sales@mainguilty.com)
  try {
    const contactForm = new URLSearchParams();
    contactForm.append("form_type", "contact");
    contactForm.append("utf8", "✓");
    contactForm.append("contact[email]", data.email);
    contactForm.append("contact[name]", `${data.first_name} ${data.last_name}`);
    contactForm.append("contact[phone]", data.phone || "");
    contactForm.append("contact[subject]", `[CRYPTO ORDER] from ${data.first_name} ${data.last_name}`);
    contactForm.append("contact[body]", emailBody);

    const submitRes = await fetch("/contact#crypto-order", {
      method: "POST",
      body: contactForm,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      redirect: "follow",
    });

    // Shopify returns 200 on success (with redirect), or the form page
    showCheckoutStep("confirm");
  } catch (err) {
    console.error("Crypto checkout submit error:", err);
    showCheckoutStep("form");
    alert("There was an error submitting your order. Please try again.");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCryptoSidebar);
} else {
  initCryptoSidebar();
}